// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609080503/js/" + chunkId + "." + {"44":"efe0e59a","225":"21526170","481":"01cbd38c","486":"4e2696de","770":"2ef8e42a"}[chunkId] + ".0.19164015319529903.chunk.js";
};